import React, { useEffect, useState } from 'react'
import { observer } from "mobx-react";
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import { useMedia } from '@commons/media'
import { Element } from 'react-scroll';
import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';
import 'swiper/css/bundle';
import './index.scss'
import MainBannerSlide from '@components/dumb/MainBannerSlide';
import RootStore from "@stores"
import { useTranslation } from 'react-i18next';
interface MainBannerProps {
}

const MainBanner: React.FC<MainBannerProps> = observer((props) => {
    const {i18n} = useTranslation();
    const language = i18n.language
    const {
        portalContent
    } = RootStore.PortalStore;

    const {mediaClass} = useMedia();

    const [mgmMainBanners, setMgmMainBanners] = useState<MainBannerProps[]>([]);

    const [swiperParams] = useState<SwiperOptions>({
        autoplay: false,
        loop:false,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        modules: [Navigation, Pagination, EffectFade],
        pagination: {
            el: ".swiper-pagination",
            renderBullet: function (index, className) {
                return `<span class='${className}'></span>`;
            }
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        on: {
            init(swiper: Swiper) {
                if (swiper.slides.length <= 1) {
                    swiper.navigation.nextEl.style.display = 'none';
                    swiper.navigation.prevEl.style.display = 'none';
                }
                // this.navigationNext.el.style.display = 'none'
            }
        }
    })

    useEffect(() => {
        let langMgmMainBanners = i18n.getResource(language, "portal", "mgmMainBanners")
        if (langMgmMainBanners) {
            console.log(langMgmMainBanners, 'mgmMainBanners');
            const swiper = new Swiper('.main-banner-swiper', swiperParams)
            setMgmMainBanners(langMgmMainBanners)
        }
    }, [portalContent, language, i18n, swiperParams])


    return (
        <Element name="main-banner">
            <div className="main-banner-swiper swiper">
                <div className="swiper-wrapper">
                    {
                        mgmMainBanners && mgmMainBanners.map((slide:any, i) => (
                            <div className="swiper-slide" key={i}><MainBannerSlide data={slide}></MainBannerSlide></div>
                        ))
                    }
                </div>
                <div className="swiper-pagination"></div>
                <div className={`swiper-button-prev ${mediaClass('swiper-prev-btn')}`}></div>
                <div className={`swiper-button-next ${mediaClass('swiper-next-btn')}`}></div>
            </div>
        </Element>
    )
})
export default MainBanner;
